/**
 * Shared chrome for Close-the-Estate SFrames (251–259): back link + title block.
 */

import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

interface ClosePhaseChromeProps {
  estateId?: string;
  title: string;
  subtitle?: string;
  children: ReactNode;
}

export default function ClosePhaseChrome({ estateId, title, subtitle, children }: ClosePhaseChromeProps) {
  const navigate = useNavigate();
  const overview = estateId ? `/sframe-250/${estateId}` : '/sframe-250';

  return (
    <div className="max-w-5xl mx-auto px-4 py-6 space-y-6">
      <button
        type="button"
        onClick={() => navigate(overview)}
        className="text-sm text-slate-600 hover:text-slate-900 hover:underline"
      >
        ← Back to Close the Estate overview
      </button>
      <header>
        <h1 className="text-2xl font-semibold text-slate-900">{title}</h1>
        {subtitle && <p className="text-slate-600 mt-2 text-sm leading-relaxed max-w-3xl">{subtitle}</p>}
      </header>
      {children}
    </div>
  );
}
